// The Sonar tab of a followed public figure's page (16 October 2026).
// Never a number of voices: shares. Never "poll" nor "voters" for those who talk about them.
export default {
  titre: 'Sonar on {qui}',
  texte: 'Ask a question, test a message or compare up to four options with the groups of those who talk about them: each reacts in its own words, and the summary says what lands, with whom, and what to avoid.',
  nouvelle: 'New study',
  chargement: 'Loading…',
  liste: 'Studies',
  vide: {
    titre: 'No study yet',
    texte: 'Run the first one: a question about {qui}, a tweet to test before posting it, or several versions of an announcement to choose between.',
  },
  genres: {
    question: { court: 'Question', titre: 'Ask a question', aide: 'What they think of a topic, a proposal, a controversy.' },
    message: { court: 'Message', titre: 'Test a message', aide: 'A post, an announcement, a response: how each group receives it.' },
    ab: { court: 'Comparison', titre: 'Compare options', aide: 'Two to four versions of a message, or proposals: each gets a score, and the best one shows at a glance.' },
  },
  enCours: 'Running…',
  enCoursLong: 'The groups are reacting: the study comes back in about a minute.',
  echec: 'Failed',
  echecLong: 'This study could not be run. Run it again.',
  barreAria: '{f}% favourable, {n}% neutral, {d}% unfavourable',
  pct: '{n}%',
  synthese: 'Key takeaways',
  sens: { favorable: 'favourable', neutre: 'neutral', defavorable: 'unfavourable' },
  retenue: 'Option {v}:',
  classement: {
    titre: 'Ranking',
    meilleure: 'Best option',
    premiere: 'Leading',
    sur: 'out of 100',
    fourchette: '{bas} ~ {haut}',
    preferent: '{n} prefer it to the others',
    enTete: 'leads, {score} out of 100',
    aria: 'Option {v}: {score} out of 100, between {bas} and {haut}',
    avance: { nette: 'Clearly ahead', courte: 'Narrowly ahead', egalite: 'Neck and neck' },
  },
  scoresGroupe: 'The score of each option in this group',
  recommandations: 'Do',
  aEviter: 'Avoid',
  parGroupe: 'Group by group',
  comme: 'like {nom}',
  reaction: '{x} reaction',
  intensite: { forte: 'Strong', nette: 'Clear', moderee: 'Moderate', faible: 'Weak' },
  relais: '{n} would share it',
  preferenceAria: '{a}% prefer A, {b}% prefer B',
  preferent: '{v}: {n}',
  voix: '{prenom}, {age}',
  pasDesElecteurs: 'Those who talk about a public figure are not their voters: these reactions show how a message travels in the conversation, not how people vote.',
  fenetre: { titre: 'New study' },
  etapes: { type: 'Type', contenu: 'Content', groupes: 'Groups' },
  champs: {
    question: 'The question',
    questionExemple: 'What do you think of {qui}’s pension proposal?',
    contexte: 'Context (optional)',
    contexteExemple: 'A tweet announcing the programme presentation',
    message: 'The message to test',
    messageExemple: 'The text as it would be posted',
    option: 'Option {v}',
  },
  groupesAide: 'The groups of those who talk about them who will react. All are selected.',
  aucunGroupe: 'No group has its persona yet: they take shape after a few days of listening.',
  ajouterOption: 'Add an option',
  retirerOption: 'Remove option {v}',
  partConversation: '{n} of the conversation',
  lancer: 'Run the study',
  manque: {
    question: 'Write the question.',
    message: 'Write the message to test.',
    versions: 'Write at least two options, none left empty.',
    groupes: 'Select at least one group.',
  },
}
